<template>
  <div class="hmacti">
    <div class="hmactiCon">
      <p class="hmac_tit  wow fadeInUp">品牌活动</p>
      <div class="hmaBox">
        <img src="~@/assets/image/act_banner.jpg" class="act_banner" />
        <p class="hmaBox_p wow fadeInUp">敬请期待</p>
      </div>
      <!-- <div class="hmactiBox clearfix ">
        <div class="hmacti_lf">
          <div class="hmacti_li1">
            <div class="hmacti_d  wow fadeInUp">
              <img :src="left.pic" class="bann_pic2" />
            </div>
            <p class="hmacti_p wow fadeInUp">{{ left.title }}</p>
          </div>
        </div>
        <div class="hmacti_rg">
          <div class="hmacti_li2">
            <div class="hmacti_d  wow fadeInUp">
              <img :src="rightTop.pic" class="bann_pic2" />
            </div>
            <p class="hmacti_p  wow fadeInUp">{{ rightTop.title }}</p>
          </div>
          <div class="hmacti_li3">
            <div class="hmacti_d  wow fadeInUp">
              <img :src="rightBottom.pic" class="bann_pic2" />
            </div>
            <p class="hmacti_p  wow fadeInUp">{{ rightBottom.title }}</p>
          </div>
        </div>

      </div> -->
    </div>
  </div>
</template>
<script>
import { WOW } from 'wowjs'
  export default {
    data () {
      return {
        left:[],
        rightTop:[],
        rightBottom:[],
      }
    },
    created () {
    },

    mounted () {
    // 在项目加载完成之后初始化wow
    this.$nextTick(() => {
      let wow = new WOW({
        live: false,
      })
      wow.init()

      this.$post("/api/homeActivity", {
        platform:'pc'
      }).then((resp) => {
          if (resp.code == 1) {
            this.left = resp.data[0] || [];
            this.rightTop = resp.data[1] || [];
            this.rightBottom = resp.data[2] || [];
          }
      })
    })
    },
    methods: {
    },
  }
</script>


// WEBPACK FOOTER //
// src/components/home/activity.vue